import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var GetAwbDocsService = /** @class */ (function () {
    function GetAwbDocsService(httpObj) {
        this.httpObj = httpObj;
    }
    GetAwbDocsService.prototype.getAWBDocument = function (awb) {
        var requestUrl = environment.baseUrl + environment.docUploadContext + environment.GET_EDM_DOCUMENT + "/" + awb;
        return this.httpObj.get(requestUrl, this.setOptions(environment.API_KEY));
    };
    GetAwbDocsService.prototype.setOptions = function (oauthToken) {
        var oauthHeader = new HttpHeaders({
            'apikey': oauthToken
        });
        var options = { headers: oauthHeader };
        return options;
    };
    GetAwbDocsService.ngInjectableDef = i0.defineInjectable({ factory: function GetAwbDocsService_Factory() { return new GetAwbDocsService(i0.inject(i1.HttpClient)); }, token: GetAwbDocsService, providedIn: "root" });
    return GetAwbDocsService;
}());
export { GetAwbDocsService };
